import { useState } from 'react'
import { Button, Layout, message } from 'antd'
import NavBar from './NavBar'
import { Outlet } from 'react-router-dom'
import ConsentGate from './appraisals/ConsentGate'
import { useUser } from './auth'
import * as api from './lib/api'

const { Content, Footer } = Layout

export default function Root () {
  const user = useUser()
  const [downloading, setDownloading] = useState(false)

  const downloadPersonalData = async () => {
    setDownloading(true)
    let url
    let link
    try {
      const { blob, filename } = await api.downloadPersonalData()
      url = window.URL.createObjectURL(blob)
      link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      message.error(error.message || 'Unable to download your personal data')
    } finally {
      link?.remove()
      if (url) window.URL.revokeObjectURL(url)
      setDownloading(false)
    }
  }

  return (
    <ConsentGate>
      <Layout style={{ minHeight: '100vh' }}>
        <NavBar />
        <Content style={{ padding: '24px 24px', maxWidth: 1400, margin: '0 auto', width: '100%' }}>
          <Outlet />
        </Content>
        <Footer style={{ textAlign: 'center', color: '#FFFFFF', fontSize: 12, padding: '16px 24px', background: 'var(--tti-grey)' }}>
          <div>V 1.0.0</div>
          {user && (
            <Button
              type='link'
              size='small'
              loading={downloading}
              onClick={downloadPersonalData}
              style={{ color: '#FFFFFF', padding: 0 }}
            >
              Download full user data record
            </Button>
          )}
        </Footer>
      </Layout>
    </ConsentGate>
  )
}
